import AdacaAPI from '..';

export type PolicyArgs = {
  nif: string;
  licensePlate: string;
  insuranceCompany?: string;
  identifier?: string;
  phone?: string;
};

export interface IPolicyResponse {
  identificador?: string;
  codigo: string;
  descripcion: string;
  codigoPoliza: string;
  tomador: string;
  intervencionAnterior?: string;
  fechaIntervencion?: Date;
  enCurso?: boolean;
}

export const getPolicy = async (args?: PolicyArgs) => {
  if (!args) throw new Error('Error');
  const { data } = await AdacaAPI.get<IPolicyResponse>(`/Auth/policy`, {
    params: {
      ...args,
    },
  });
  return data;
};

export const getPolicyOnDemand = async (args?: PolicyArgs) => {
  if (!args) throw new Error('Error');
  const { data } = await AdacaAPI.get<IPolicyResponse>('/Auth/policy/on-demand', {
    params: {
      ...args,
    },
  });
  return data;
};
